import { create } from "zustand";

interface ICPActiveDesks {
  widgetID: string | undefined;
  ESID: string;
}

interface IShowDeskStore {
  showingDesksList: ICPActiveDesks[];
  // eslint-disable-next-line no-unused-vars
  setShowingDeskList: (incomingData: ICPActiveDesks[]) => void;
}

const showDesksStore = create<IShowDeskStore>((set) => ({
  showingDesksList: [],
  setShowingDeskList: (incomingData) => set({ showingDesksList: incomingData }),
}));

export default showDesksStore;
